define(function (require) {
	// general
	const CN = require('civicsUtils/constants');
	const ViewManager = require('civicsUtils/view_manager');
	// templates
	const tpl = require('civicsViews/logs_view/templates/t_lov_logs.hbs');
	// views
	const LogsCompositeView = require('civicsViews/logs_view/v_cpv_logs');

	return Marionette.LayoutView.extend({
		initialize: function (options) {
			if (__DEV__) console.log('lov_logs -- initialize');
			this.config = options.config;
			this.collection = options.collection;
			this.currentSort = options.initialLogsSort;
			this.showAllItems = false;
			this.expanded = {value: false};
		},
		template: tpl,
		regions: {
			tableViewRegion: '@ui.content',
		},
		ui: {
			content: '.logs-list',
			btnSortDate: '.btnSortDate',
			iconSortDate: '.icon-sort-date',
			noLogs: '.no-logs',
			header: '.list-view-header',
		},
		events: {
			'click @ui.btnSortDate': 'sortByDateClicked',
		},
		onRender: function () {
			if (__DEV__) console.log('lov_logs -- onRender');

			if (this.collection.isEmpty()) {
				this.ui.header.hide();
			}
			else {
				this.ui.noLogs.hide();
			}
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInit();
		},
		onShow: function () {
			if (__DEV__) console.log('lov_logs -- onShow');

			// Logs Composite View
			this.logsCompositeView = new LogsCompositeView({
				config: this.config,
				collection: this.collection,
				currentSort: this.currentSort,
				showAllItems: this.showAllItems,
				expanded: this.expanded
			});
			this.tableViewRegion.show(this.logsCompositeView);
			this.$el.rhythmThemeInit();
		},
		isDesktopViewVisible: function () {
			return this.ui.content.css('display') != 'none';
		},
		sortByDateClicked: function () {
			if (__DEV__) console.log('cpv_logs sortByDateClicked');
			this.currentSort.field = 'startDateTime';
			this.currentSort.direction = this.ui.iconSortDate.hasClass('up') ? CN.SORT_DESC : CN.SORT_ASC;
			this.collection.sort(this.currentSort.field, this.currentSort.direction);
			this.ui.iconSortDate.toggleClass('up down');
		},
		templateHelpers: function () {
			return {
				count: this.collection.length,
			};
		},
	});
});
